<template>
  <div>
    <Printable />
  </div>
</template>

<script>
import Printable from '@/nfmp_components/printable.vue'
export default {
  components: {
    Printable
  }
}
</script>